module.exports = {
    mapLocale: {
        'fr': 'fr',
        'en-CA': 'ca',
        'de': 'de'
    }
}